var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-sm mb-8 template-content",domProps:{"innerHTML":_vm._s(_vm.template)}})}
var staticRenderFns = []

export { render, staticRenderFns }